<template>
  <div
    class="card flex flex-col cursor-pointer justify-between gap-4 border-1 border-surface-600 rounded-24px bg-white p-4 transition hover:(b-surface-700 shadow-md)"
  >
    <slot />
  </div>
</template>
